import {
  useAssistantChatMutation as useGeneratedAssistantChatMutation,
  useAssistantRateConversationMutation as useGeneratedAssistantRateConversationMutation,
} from '@graphql/generated/graphql';

export function useAssistantChatMutation() {
  return useGeneratedAssistantChatMutation({ retry: false });
}

export function useAssistantRateConversationMutation() {
  return useGeneratedAssistantRateConversationMutation({ retry: false });
}
